import { Checkbox } from '@hologram-dimension/checkbox';
import { TextInput } from '@hologram-dimension/text-input';
import useOrganizationDetails from 'api/legacy/organization/useOrganizationDetails';
import { type FC, useCallback } from 'react';
import useSimInventoryStore from 'state/SimInventory/useSimInventoryStore';
import useSimInventoryStoredFilters from 'state/SimInventory/useSimInventoryStoredFilters';
import { filterLabels } from 'components/SimInventoryFilters/shared';
import FilterAccordion, { type FilterProps } from '../../FilterAccordion/FilterAccordion';
import filterStyles from '../filterStyles.module.css';

const OrganizationFilter: FC<FilterProps> = ({ form, onClear, submit }) => {
  const storedFilters = useSimInventoryStoredFilters();
  const storedOrgId = storedFilters?.organizationId;
  const setOrganizationIdFilter = useSimInventoryStore((state) => state.setOrganizationIdFilter);
  const { register } = form;

  const orgIdField = register('organizationId', {
    onBlur: () => {
      submit();
    },
  });

  const { organization, error, isLoading } = useOrganizationDetails(storedOrgId);

  let orgLabel;

  if (isLoading) {
    orgLabel = `...${storedOrgId}...`;
  } else if (error) {
    orgLabel = `${storedOrgId}`;
  } else if (organization?.name) {
    orgLabel = organization.name;
  } else {
    orgLabel = `${storedOrgId}`;
  }

  const onChange = useCallback(() => {
    setOrganizationIdFilter(undefined);
    submit();
  }, [setOrganizationIdFilter, submit]);

  const onKeyUp = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        submit();
      }
    },
    [submit]
  );

  return (
    <FilterAccordion
      onClear={onClear}
      label={filterLabels.organizationId}
      isSet={storedOrgId !== undefined}
      defaultActive={storedOrgId !== undefined}
    >
      <div className={filterStyles.defaultWrapper}>
        <TextInput
          id="organizationId"
          type="number"
          inputProps={{ 'data-1p-ignore': true, 'data-lpignore': true } as any}
          onKeyUp={onKeyUp}
          {...orgIdField}
        />
        {storedOrgId && (
          <>
            <hr className={filterStyles.divider} />
            <Checkbox
              name={storedOrgId.toString()}
              defaultChecked
              label={orgLabel}
              onChange={onChange}
            />
          </>
        )}
      </div>
    </FilterAccordion>
  );
};

export default OrganizationFilter;
